import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Upload a device image to durable object storage. Returns { image_url, image_path }.
export async function uploadExerciseImage(file) {
  const token = localStorage.getItem('token');
  const form = new FormData();
  form.append('file', file);
  const res = await axios.post(`${API}/exercises/upload-image`, form, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}
